export default __webpack_public_path__ + "static/media/HH50164.ffd18163.jpg";